import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Button } from '@/ui';
import { COMPANY_ADVANTAGES, CONTACT_INFO } from '@/constants/navigation';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { colors } from '@/theme/colors';
export const Home = () => {
    const navigate = useNavigate();
    const handleCategoryClick = (categoryPath) => {
        navigate(categoryPath);
    };
    return (_jsxs(HomePage, { children: [_jsx(HeroSection, { children: _jsx(Container, { size: "large", children: _jsxs(HeroContent, { children: [_jsxs(HeroText, { children: [_jsxs(HeroTitle, { children: ["\u0421\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B", _jsx(HeroTitleAccent, { children: " \u0434\u043B\u044F \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u043E\u0432" })] }), _jsx(HeroDescription, { children: "Legarta - \u0432\u0435\u0434\u0443\u0449\u0438\u0439 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0438 \u043E\u0442\u0434\u0435\u043B\u043E\u0447\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0432 \u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A\u0435. \u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0441\u043A\u043B\u0430\u0434, \u043F\u0440\u044F\u043C\u044B\u0435 \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u0441 \u0437\u0430\u0432\u043E\u0434\u0430, \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043D\u043E\u0435 \u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435." }), _jsxs(HeroActions, { children: [_jsx(Button, { variant: "primary", size: "large", children: "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043F\u0440\u043E\u0434\u0443\u043A\u0446\u0438\u0438" }), _jsx(Button, { variant: "outline", size: "large", children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E" })] })] }), _jsx(HeroVisual, { children: _jsxs(HeroImagePlaceholder, { children: [_jsx(HeroImageText, { children: "\uD83D\uDD28" }), _jsx(HeroImagePlaceholderText, { children: "\u0421\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B" })] }) })] }) }) }), _jsx(AdvantagesSection, { children: _jsxs(Container, { size: "large", children: [_jsxs(SectionHeader, { children: [_jsx("h2", { children: "\u041F\u043E\u0447\u0435\u043C\u0443 \u0432\u044B\u0431\u0438\u0440\u0430\u044E\u0442 Legarta" }), _jsx("p", { children: "\u041C\u044B \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u043C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0438 \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u0441\u0442\u044C \u043D\u0430 \u043A\u0430\u0436\u0434\u043E\u043C \u044D\u0442\u0430\u043F\u0435" })] }), _jsx(AdvantagesGrid, { children: COMPANY_ADVANTAGES.map((advantage) => (_jsx(AdvantageCard, { variant: "elevated", children: _jsxs(AdvantageContent, { children: [_jsx(AdvantageIcon, { children: advantage.icon }), _jsx(AdvantageTitle, { children: advantage.title }), _jsx(AdvantageDescription, { children: advantage.description })] }) }, advantage.id))) })] }) }), _jsx(ProductsPreviewSection, { children: _jsxs(Container, { size: "large", children: [_jsxs(SectionHeader, { children: [_jsx("h2", { children: "\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0446\u0438\u0438" }), _jsx("p", { children: "\u0428\u0438\u0440\u043E\u043A\u0438\u0439 \u0430\u0441\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442 \u0434\u043B\u044F \u043B\u044E\u0431\u044B\u0445 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0437\u0430\u0434\u0430\u0447" })] }), _jsx(ProductsGrid, { children: _jsx(ProductCategoryCard, { variant: "elevated", children: _jsxs(ProductCategoryContent, { children: [_jsx(ProductCategoryIcon, { children: "\uD83C\uDFA8" }), _jsx(ProductCategoryTitle, { children: "\u042D\u043C\u0430\u043B\u0438" }), _jsx(ProductCategoryDescription, { children: "\u041B\u0430\u043A\u043E\u043A\u0440\u0430\u0441\u043E\u0447\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B" }), _jsx(Button, { variant: "outline", size: "small", onClick: () => handleCategoryClick('/enamels'), children: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435" })] }) }) })] }) }), _jsx(ContactSection, { children: _jsx(Container, { size: "large", children: _jsxs(ContactContent, { children: [_jsxs(ContactInfo, { children: [_jsx("h2", { children: "\u0421\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438" }), _jsx("p", { children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430 \u0438\u043B\u0438 \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u0435 \u0437\u0430\u043A\u0430\u0437" }), _jsxs(ContactDetails, { children: [_jsxs(ContactDetail, { children: [_jsx(PhoneOutlined, { style: { color: colors.primary, fontSize: 20, marginTop: 2 } }), _jsxs(ContactDetailContent, { children: [_jsx("h4", { children: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D" }), _jsx("p", { children: CONTACT_INFO.phone })] })] }), _jsxs(ContactDetail, { children: [_jsx(MailOutlined, { style: { color: colors.primary, fontSize: 20, marginTop: 2 } }), _jsxs(ContactDetailContent, { children: [_jsx("h4", { children: "Email" }), _jsx("p", { children: CONTACT_INFO.email })] })] }), _jsxs(ContactDetail, { children: [_jsx(EnvironmentOutlined, { style: { color: colors.primary, fontSize: 20, marginTop: 2 } }), _jsxs(ContactDetailContent, { children: [_jsx("h4", { children: "\u0410\u0434\u0440\u0435\u0441" }), _jsx("p", { children: CONTACT_INFO.address })] })] })] }), _jsx(Button, { variant: "primary", size: "large", children: "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u043E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A" })] }), _jsx(ContactVisual, { children: _jsxs(ContactImagePlaceholder, { children: [_jsx(ContactImageText, { children: "\uD83C\uDFE2" }), _jsx(ContactImagePlaceholderText, { children: "\u041D\u0430\u0448 \u043E\u0444\u0438\u0441 \u0432 \u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A\u0435" })] }) })] }) }) })] }));
};
const HomePage = styled.div `
  min-height: 100vh;
`;
const HeroSection = styled.section `
  background: ${colors.gradientHero};
  padding: 120px 0 80px;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 80px 0 60px;
  }

  @media (max-width: 480px) {
    padding: 60px 0 40px;
  }
`;
const HeroContent = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 1024px) {
    gap: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
`;
const HeroText = styled.div ``;
const HeroTitle = styled.h1 `
  font-size: 48px;
  font-weight: 700;
  color: ${colors.textPrimary};
  margin: 0 0 24px 0;
  line-height: 1.2;

  @media (max-width: 1024px) {
    font-size: 40px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;
const HeroTitleAccent = styled.span `
  color: ${colors.primary};
`;
const HeroDescription = styled.p `
  font-size: 18px;
  color: ${colors.textSecondary};
  line-height: 1.6;
  margin: 0 0 32px 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;
const HeroActions = styled.div `
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;
const HeroVisual = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
const HeroImagePlaceholder = styled.div `
  background: ${colors.backgroundPrimary};
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 20px 40px ${colors.shadowLight};
  max-width: 400px;
  width: 100%;
`;
const HeroImageText = styled.span `
  font-size: 80px;
  display: block;
  margin-bottom: 20px;
`;
const HeroImagePlaceholderText = styled.p `
  font-size: 18px;
  color: ${colors.textSecondary};
  margin: 0;
  font-weight: 500;
`;
const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 36px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin: 0 0 16px 0;

    @media (max-width: 1024px) {
      font-size: 32px;
    }

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  p {
    font-size: 18px;
    color: ${colors.textSecondary};
    margin: 0;
    max-width: 600px;
    margin: 0 auto;
  }
`;
const AdvantagesSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundPrimary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const AdvantagesGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
const AdvantageCard = styled(Card) `
  text-align: center;
  height: 100%;
`;
const AdvantageContent = styled.div `
  padding: 20px;
`;
const AdvantageIcon = styled.div `
  font-size: 48px;
  margin-bottom: 20px;
`;
const AdvantageTitle = styled.h3 `
  font-size: 20px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 12px 0;
`;
const AdvantageDescription = styled.p `
  color: ${colors.textSecondary};
  line-height: 1.5;
  margin: 0;
`;
const ProductsPreviewSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundSecondary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const ProductsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  align-items: stretch;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
const ProductCategoryCard = styled(Card) `
  text-align: center;
  height: 100%;
`;
const ProductCategoryContent = styled.div `
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
`;
const ProductCategoryIcon = styled.div `
  font-size: 48px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ProductCategoryTitle = styled.h3 `
  font-size: 20px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 12px 0;
  text-align: center;
  width: 100%;
`;
const ProductCategoryDescription = styled.p `
  color: ${colors.textSecondary};
  line-height: 1.5;
  margin: 0 0 20px 0;
  text-align: center;
  width: 100%;
`;
const ContactSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundPrimary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const ContactContent = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 1024px) {
    gap: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
`;
const ContactInfo = styled.div `
  h2 {
    font-size: 36px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin: 0 0 16px 0;

    @media (max-width: 1024px) {
      font-size: 32px;
    }

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  > p {
    font-size: 18px;
    color: ${colors.textSecondary};
    line-height: 1.6;
    margin: 0 0 32px 0;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`;
const ContactDetails = styled.div `
  margin-bottom: 32px;
`;
const ContactDetail = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;
const ContactDetailIcon = styled.span `
  color: ${colors.primary};
  font-size: 20px;
  margin-top: 2px;
`;
const ContactDetailContent = styled.div `
  h4 {
    font-size: 16px;
    font-weight: 600;
    color: ${colors.textPrimary};
    margin: 0 0 4px 0;
  }

  p {
    color: ${colors.textSecondary};
    margin: 0;
  }
`;
const ContactVisual = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ContactImagePlaceholder = styled.div `
  background: ${colors.backgroundSecondary};
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  border: 2px dashed ${colors.borderMedium};
  max-width: 400px;
  width: 100%;
`;
const ContactImageText = styled.span `
  font-size: 80px;
  display: block;
  margin-bottom: 20px;
`;
const ContactImagePlaceholderText = styled.p `
  font-size: 18px;
  color: ${colors.textSecondary};
  margin: 0;
  font-weight: 500;
`;
